import React, { useState, useEffect } from "react";
import { Card, CardBody, CardFooter, CardTitle, Row, Col, Spinner, FormGroup, Button } from "reactstrap";
import MaterialTable from 'material-table';
import Select from 'react-select';

// style
import { table_translate, table_style } from "../../constants/MaterialTable.js";

// helpers
import { showMessage } from "../../helpers/message.js";

// api
import estoque_api from "../../api/estoque_api";
import local_api from "../../api/local_api";

//Context
import { useAuth } from "../../context/auth.js";

export default function Dashboard({ item, handleReturn }) {
  const { session, setLoading } = useAuth();
  
  const [dashboard, set_dashboard] = useState();

  const loadDashboard = (localId) => {
    setLoading(true);
    estoque_api.getDashboard(localId)
      .then(result => set_dashboard(result.data))
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false))
  }

  const [localSelect, set_localSelect] = useState(null);
  const [locais, set_locais] = useState([]);
  const loadLocais = () => {
    setLoading(true);
    local_api.getListAtivosByUsuarioId(session.usuarioId).then(result => {
      if (result.data.length == 0) {
        showMessage("Aviso", "Nenhum PEV cadastrado.", 'error', null);
        return;
      }
      set_locais(result.data);
    })
      .catch(err => showMessage("Aviso", err.message, 'error', null))
      .finally(() => setLoading(false))
  }

  const handleLocal = (value) => {
    set_localSelect(value);
  }

  useEffect(() => {
    loadLocais();
    loadDashboard(session.localId);
  }, []);


  return (
    <>
      <div className="content">
        {session.perfil == "ADM" && <Row >
          <Col md="12" lg="3" className="my-2">
            <FormGroup>
              <label className="form-control-label">Selecione o Local:</label>
              <Select
                name="local"
                options={locais}
                getOptionLabel={p => p.identificacao}
                getOptionValue={p => p.localId}
                value={localSelect == null ? locais.find(obj => obj.localId === session.localId) : localSelect != null ? locais.find(obj => obj.localId === localSelect.localId) : null}
                onChange={(e) => { handleLocal(e) }}
                classNamePrefix="select"
                placeholder="[ Selecione ]"
              />
            </FormGroup>
          </Col>
          <Col md="12" lg="3" className="mt-2">
            <br />
            <Button color={"primary"} onClick={() => loadDashboard(localSelect != null ? localSelect.localId : session.localId)}>
              <i className="fa fa-search"></i>
            </Button>
          </Col>
        </Row>}
        <Row>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center text-warning">
                      <i class="fas fa-box-open"></i>
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Lotação</p>
                      <CardTitle tag="p">{dashboard != null ? dashboard.lotacaoM3 : 0} m³</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  Metro Cúbico
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center text-success">
                      <i class="fas fa-prescription-bottle"></i>
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Lotação</p>
                      <CardTitle tag="p">{dashboard != null ? dashboard.lotacaoL : 0} L</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  Litros
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center text-danger">
                      <i class="fas fa-weight"></i>
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Lotação</p>
                      <CardTitle tag="p">{dashboard != null ? dashboard.lotacaoKg : 0} kg</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  Quilogramas
                </div>
              </CardFooter>
            </Card>
          </Col>
          <Col lg="3" md="6" sm="6">
            <Card className="card-stats">
              <CardBody>
                <Row>
                  <Col md="4" xs="5">
                    <div className="icon-big text-center text-info">
                      <i className="fas fa-boxes" />
                    </div>
                  </Col>
                  <Col md="8" xs="7">
                    <div className="numbers">
                      <p className="card-category">Lotação</p>
                      <CardTitle tag="p">{dashboard != null ? dashboard.lotacaoUN : 0} un</CardTitle>
                      <p />
                    </div>
                  </Col>
                </Row>
              </CardBody>
              <CardFooter>
                <hr />
                <div className="stats">
                  Unidades
                </div>
              </CardFooter>
            </Card>
          </Col>
        </Row>
        <Row>
          <Col lg="12" md="12" sm="12">
            <MaterialTable
              title="Estoque de Resíduos"
              columns={[
                { title: 'Resíduo', field: 'tipoResiduoDescricao' },
                { title: 'Quantidade', field: 'quantidade' },
                { title: 'Unidade', field: 'unidade' }
              ]}
              data={dashboard != null ? dashboard.estoque : []}
              isLoading={false}
              options={{
                ...table_style,
                filtering: false,
                exportButton: true
              }}
              localization={table_translate}
            />
          </Col>
        </Row>
      </div>
    </>
  );
}

